import * as React from 'react';
import * as ThemeUI from 'theme-ui';

export type ImageProps = ThemeUI.ImageProps;

export const Image: React.FC<ImageProps> = ({ ...props }) => (
  <ThemeUI.Image {...props} />
);
